import { Col } from "reactstrap";
import { BlogDetailsData } from "../../../Data/Blog/Blog";
import { SocialGroupData } from "../../../Data/Layout/Footer";
import { dynamicImage, Image } from "../../../Utils";
import { Href } from "../../../Constants/Constants";

const Details = () => {
  return (
    <Col sm="12">
      <div className="blog-detail blog-card">
        <Image className="img-fluid w-100" src={dynamicImage("blog/blog-detail.jpg")} alt="" />
        <h2 className="mt-3">{"Also the leap into electronic typesetting unchanged."}</h2>
        <div className="post-social my-2">
          <ul className="d-flex flex-wrap align-items-center gap-2 my-2">
            <li>{"25 January 2024"}</li>
            <li><i className="fa fa-user mx-1" />Admin</li>
            <li><i className="fa fa-comments mx-1" /> 10 Comment</li>
          </ul>
          <ul className="social-group">
            {SocialGroupData.map((item, index) => (
              <li key={index}>
                <a className={`icon-btn btn-${item.class} button-effect btn-sm`} href={item.url} target="_new">
                  <i className={`fa fa-${item.icon}`} />
                </a>
              </li>
            ))}
          </ul>
        </div>
        <p>{"Fusce scelerisque augue a viverra semper. Etiam nisi nibh, vestibulum quis augue id, imperdiet fringilla dolor. Nulla sed nisl vel nisi cursus finibus. Vivamus ut augue nec justo viverra laoreet. Nunc efficitur, arcu ac cursus gravida, lorem elit commodo urna, id viverra libero tellus non ipsum. Fusce molestie ultrices nibh feugiat pretium. Donec pulvinar arcu metus, et dapibus odio condimentum id. Quisque malesuada mauris sit amet dui feugiat, ut pretium mauris luctus. Ut aliquam, tellus nec molestie condimentum, tellus arcu dignissim quam, a gravida nunc nulla vel magna. Sed pulvinar tortor et euismod blandit. Proin accumsan orci ac nunc fermentum vehicula."}</p>
        <p>{"Cras quis neque urna. Pellentesque mollis, dui nec elementum elementum, ipsum quam suscipit ligula, sit amet lobortis dolor sem sed neque. Vivamus consequat est non sodales efficitur. Aliquam sodales eleifend sodales. Aliquam auctor ipsum quis nisl facilisis, at convallis mauris iaculis. Duis eleifend, magna ac convallis blandit, dui dui auctor leo, sed tincidunt nisi mauris ut nulla. Praesent porttitor dui ac turpis commodo porttitor. Integer ligula nisi, bibendum non sem at, porta condimentum dui."}</p>
        <p>{"Proin id eleifend diam, euismod dictum nibh. Ut ullamcorper in purus at tempor. Nullam mattis risus nec velit semper lobortis. Donec accumsan ligula fermentum, ultricies massa eget, cursus leo. Suspendisse placerat elit et lacus aliquam, ut elementum leo aliquet. Integer ornare, ipsum eu lacinia viverra, lectus ipsum scelerisque nisl, nec iaculis leo elit id arcu. Aliquam id ante elit. Donec commodo purus eget lacus pharetra, et egestas metus blandit. Quisque pellentesque porta urna, sed dictum enim viverra a."}</p>
        <ul className="tags border-0 mb-0 pb-0">
          {BlogDetailsData.map((item, index) => (
            <li key={index}><a href={Href}>{item}</a></li>
          ))}
        </ul>
      </div>
    </Col>
  );
};

export default Details;
